import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    list: [],
    deletedImages: []
  },
  getters: {},
  mutations: {
    setList (state, list) {
      state.list = list
    },
    addDeletedImage (state, deletedImage) {
      state.deletedImages.every(image => image._id !== deletedImage._id) && state.deletedImages.push(deletedImage)
    },
    clearDeletedImages (state) {
      state.deletedImages = []
    }
  },
  actions: {
    async storePayRecords ({rootState, commit}) {
      commit('setList', await api.getPayRecords(rootState.project.current._id))
    },
    getPayRecord ({rootState}, _id) {
      return api.getPayRecord(rootState.project.current._id, _id)
    },
    async delete ({rootState}, _id) {
      await api.deletePayRecord(rootState.project.current._id, _id)
    },
    async updateTotalCost ({rootState}, {id, cost}) {
      await api.updatePayRecordTotalCost(rootState.project.current._id, id, cost)
    },
    async addPayRecord ({rootState, dispatch}, data) {
      const newInvoice = {...data}
      delete newInvoice.images
      const _id = await api.addPayRecord(rootState.project.current._id, newInvoice)
      try {
        for (const image of data.images) {
          await dispatch('addImage', {invoiceId: _id, description: image.description, date: image.date, imageData: image.file, extension: image.file.name.split('.').pop()})
        }
      } catch (error) {
        alert('新增照片失敗!')
        console.warning(error)
      }
    },
    async updatePayRecord ({rootState, state, commit, dispatch}, payRecord) {
      const _payRecord = {...payRecord}
      const originImages = _payRecord.images.filter(image => !image.file && image.src)
      _payRecord.images = originImages
      await api.updatePayRecord(rootState.project.current._id, _payRecord)

      // 新增新圖片
      for (const image of payRecord.images.filter(image => image.file)) {
        await dispatch('addImage', {invoiceId: payRecord._id, description: image.description, imageData: image.file, extension: image.file.name.split('.').pop()})
      }

      // 刪除舊圖片
      for (const image of state.deletedImages) {
        await api.deleteInvoiceImage(rootState.project.current._id, payRecord._id, image._id)
      }
      commit('clearDeletedImages')
    },
    async addImage ({state, rootState}, {invoiceId, imageData, extension, description, date}) {
      const { location } = await api.addInvoiceImageMeta(rootState.project.current._id, invoiceId, {extension, description, date})
      await api.addInvoiceImageContent(location, imageData)
    },
    async approvedPayRecord ({rootState, dispatch}, _id) {
      await api.approvedPayRecord(rootState.project.current._id, _id)
      await dispatch('storePayRecords')
    },
    async downloadPayRecord ({rootState}, payRecord) {
      const result = await api.downloadPayRecord(rootState.project.current._id, payRecord._id)
      require('downloadjs')(result, `第${payRecord.times}次估驗計價.zip`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/payRecord.js